@import '../../global/style/all-tenants/custom-properties/components-properties/splide-sliders';

:host {
  @include cms-components-host-defaults;
}

cms-headline {
  --cms-spacing-bottom: var(--cms-spacing-100);
}

.cms-article-slider-inner {
  @include cms-default-grid-container;
}

.splide {
  @include splide-root;
}

.splide__track--draggable {
  @include splide-track-draggable;
}

.splide__sr {
  @include splide-sr;
}

.splide__container {
  @include splide-container;
}

.splide__track {
  @include splide-track;
}

.splide__list {
  @include splide-list;
  grid-template-rows: 99%;
}

.splide.is-initialized:not(.is-active) .splide__list {
  @include splide-initialized-not-active;
}

.splide.is-initialized,
.splide.is-rendered {
  @include splide-initialized-rendered;
}

.splide__slide {
  @include splide-slide;

}

.splide__slide__container {
  @include splide-slide-container(flex-start);
  /* Override the default "space-between" */
}

.splide-arrow {
  @include splide-arrow;
}

.splide__arrow--prev {
  @include splide-arrow-prev;
}

.splide__arrow--next {
  @include splide-arrow-next;
}

.article-image-wrapper {
  margin-bottom: var(--cms-spacing-075);
}

.article-slider-cta {
  --cms-theme-text-color: var(--cms-semanticColors-base-strong-text);
  color: var(--cms-theme-text-color);
  text-decoration: none;
}

.article-slider-list {
  --cms-theme-background-color: var(--cms-semanticColors-container-weak-background);
  --cms-theme-border-color: var(--cms-semanticColors-container-weak-border);
  background-color: var(--cms-theme-background-color);
  border: var(--cms-border-size-xs) solid var(--cms-theme-article-slider-border-color);
}


@include media-width($breakpoint-sm) {
  cms-headline {
    --cms-spacing-bottom: var(--cms-spacing-150);
  }
}